module.exports = __webpack_public_path__ + "static/media/1012881.0779a420.png";